export const en = {
    'message-failure': 'Could not invite users to the organization',
    'message-failure-users': 'Could not invite to the organization:',
    'message-success': 'Invited to the organization:'
};
